import { render, staticRenderFns } from "./NoticeTemplate.vue?vue&type=template&id=96843464&scoped=true"
import script from "./NoticeTemplate.vue?vue&type=script&lang=js"
export * from "./NoticeTemplate.vue?vue&type=script&lang=js"
import style0 from "./NoticeTemplate.vue?vue&type=style&index=0&id=96843464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96843464",
  null
  
)

export default component.exports